import React, { useEffect } from 'react'

import { useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'

const WelcomeView = withRouter(({ history }) => {
  const products = useSelector(state => state.profile && state.profile.products)

  useEffect(() => {
    const currentApplication = products.SOCCER ? 'SOCCER' : products.OLD_DELEGATE ? 'OLD_DELEGATE' : products.OLD_CM ? 'OLD_CM' : Object.keys(products)[0]
    if (currentApplication === 'OLD_CM') {
      history.push('/cm')
    } else if (currentApplication === 'OLD_DELEGATE') {
      history.push('/cm/delegate')
    } else if (currentApplication === 'SOCCER') {
      history.push('/soccer')
    } else if (currentApplication === 'ADMIN') {
      history.push('/admin')
    }
  }, [products, history])

  return (
    <div>
      <div>Welcome To RefereePro</div>
    </div>
  )
})

export default WelcomeView